export default __webpack_public_path__ + "static/media/mode-31.d780541e.svg";